// extracted by mini-css-extract-plugin
module.exports = {"container":"_3PqSqqMJ","error":"_3Vgm4Pka","warning":"_1d4-5gP7","pagination":"_1QvUM3PM"};